import styled from "styled-components"

const Cursor = styled.div`
  display: ${(props) => (props.block ? 'block' : 'inline')};
  cursor: ${(props) => props.name || 'pointer'};
`

export default Cursor
